import { HStack, Text } from '@chakra-ui/react'
import { useContext } from 'react'
import { useDropzoneStyles } from '~/components/shared/componentStyles/Dropzone.style'

import { Context } from './Context'

export default function ContentDragAccepted() {
  const {
    currentVariant,
    props: { dropOKText = 'OK to drop!' },
  } = useContext(Context)

  const styles = useDropzoneStyles({
    variant: currentVariant,
  })

  return (
    <HStack>
      <Text sx={styles.text}>{dropOKText}</Text>
    </HStack>
  )
}
